<template lang="pug">
  #nav
    template(v-for="(link, index) in links")
      router-link(:to="resolved(link.path)") {{ link.text }}
      span(v-if="index != links.length - 1") &nbsp;|&nbsp;
</template>

<script>
  export default {
    name: 'Navigation',
    props: {
      routes: {
        type: Array,
        required: true
      },
      ns: {
        type: String,
        required: false
      }
    },
    computed: {
      links () {
        return this.routes.filter(route => route.text)
      }
    },
    methods: {
      resolved (path) {
        return this.ns ? `/${this.ns}/${path}` : path
      }
    },
    data () {
      return {
      }
    }
  }
</script>

<style lang="sass">
  #nav
    padding: 30px
    a, span
      font-weight: bold
      color: #2c3e50
      &.router-link-exact-active
        color: #42b983
</style>
